var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"id":"graphic_pbi","width":"100%","height":"900px","src":_vm.linkIframe,"frameborder":"0","allowFullScreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }